<template>
  <div class="row">
    <DeleteConfirmation
      :currentDeleteMethod="deleteCatalogue"
      @delete="$event()"
    />
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center py-3">
        <div>
          <span class="titleCard mb-2">
            Catalogue
          </span>
        </div>

        <div
          class="d-flex justify-content-end align-items-center searchContainer"
        >
          <div class="filterWrapper">
            <el-select
              class="select-default"
              size="large"
              placeholder="Catalogue Type"
              v-model="catalogue_type"
              name="catalogueType"
            >
              <el-option
                v-for="option in cataloguetypes"
                class="select-default"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </div>
          <div>
            <el-input
              type="search"
              style="width: 200px;"
              ref="searchKey"
              placeholder="Search records"
              prefix-icon="el-icon-search"
              v-model="searchQuery"
              @input="debounceInput"
              aria-controls="datatables"
            />
          </div>
          <div>
            <span class="demo-input-label ml-2 perPage">Results per page:</span>
            <el-select
              class="select-default ml-1"
              v-model="pagination.perPage"
              style="width: 80px;"
              placeholder="Per page"
              :change="changeperpage(pagination.perPage)"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>

          <div class="mx-2 mt-1">
            <el-button type="primary" icon="el-icon-plus" @click="addUser">
              Add Catalogue
            </el-button>
          </div>
        </div>
      </div>

      <div
        class="d-flex justify-content-end align-items-center px-3"
        style="gap: 6px; margin-bottom: 8px;"
      >
        <el-select
          class="select-default"
          size="large"
          placeholder="Type"
          v-model="autoGenType"
          style="width: 140px;"
        >
          <el-option
            v-for="option in cataloguetypes"
            class="select-default"
            :value="option.value"
            :label="option.label === 'All' ? 'All types' : option.label"
            :key="'gen-' + option.label"
          ></el-option>
        </el-select>
        <el-button
          type="warning"
          icon="el-icon-magic-stick"
          :loading="autoGenLoading"
          @click="autoGenerateRun(true)"
        >
          Auto-Generate Canonical URLs
        </el-button>
        <el-dropdown
          trigger="click"
          @command="handleBulkAction"
          style="margin-left: 6px;"
        >
          <el-button type="primary" icon="el-icon-setting">
            Bulk Actions
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="bulk-metadata-upsert">
              <i class="el-icon-edit"></i>
              Add/Update Metadata Keys
            </el-dropdown-item>
            <el-dropdown-item command="bulk-metadata-delete" divided>
              <i class="el-icon-delete"></i>
              Delete Metadata Keys
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <b-modal
        id="autoGenCatalogueModal"
        ref="autoGenModal"
        :title="
          autoGenStage === 'preview'
            ? 'Auto-Generate — Preview'
            : 'Auto-Generate — Result'
        "
        :ok-title="autoGenStage === 'preview' ? 'Apply' : 'Close'"
        :cancel-title="autoGenStage === 'preview' ? 'Cancel' : null"
        :ok-only="autoGenStage !== 'preview'"
        :ok-variant="autoGenStage === 'preview' ? 'warning' : 'primary'"
        :busy="autoGenLoading"
        no-close-on-backdrop
        @ok="onAutoGenModalOk"
      >
        <div v-if="autoGenStage === 'preview' && autoGenResult">
          <p>
            Will generate canonical URLs for
            <strong>{{ autoGenResult.scanned || 0 }}</strong>
            <template v-if="autoGenType">
              <strong>{{ autoGenType }}</strong>
            </template>
            catalogue(s) that don't have one yet.
          </p>
          <p class="text-muted" style="font-size: 13px;">
            Records that already have a canonical URL are left untouched. Apply
            to commit.
          </p>
          <div
            v-if="autoGenResult.preview && autoGenResult.preview.length"
            style="
              max-height: 260px;
              overflow: auto;
              border: 1px solid #eee;
              padding: 8px;
              border-radius: 4px;
            "
          >
            <table style="width: 100%; font-size: 13px;">
              <thead>
                <tr style="border-bottom: 1px solid #eee;">
                  <th style="text-align: left; padding: 4px 6px;">Name</th>
                  <th style="text-align: left; padding: 4px 6px;">Slug</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in autoGenResult.preview" :key="row.id">
                  <td style="padding: 4px 6px;">{{ row.name }}</td>
                  <td style="padding: 4px 6px;">
                    <code>{{ row.canonicalUrl }}</code>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p v-else class="text-muted" style="font-size: 13px;">
            Nothing to generate — all catalogues of this type already have
            canonical URLs.
          </p>
        </div>
        <div v-else-if="autoGenStage === 'result' && autoGenResult">
          <p>
            <strong>
              {{ autoGenResult.modified || autoGenResult.generated || 0 }}
            </strong>
            canonical URL(s) generated.
          </p>
          <ul style="margin: 0; padding-left: 18px; font-size: 13px;">
            <li>Scanned: {{ autoGenResult.scanned || 0 }}</li>
            <li>Skipped (already had URL): {{ autoGenResult.skipped || 0 }}</li>
            <li v-if="autoGenResult.failed">
              Failed: {{ autoGenResult.failed }}
            </li>
          </ul>
          <div
            v-if="autoGenResult.errors && autoGenResult.errors.length"
            style="
              margin-top: 8px;
              max-height: 160px;
              overflow: auto;
              font-size: 12px;
              color: #a00;
            "
          >
            <p style="margin-bottom: 4px;"><strong>Errors:</strong></p>
            <ul style="margin: 0; padding-left: 18px;">
              <li
                v-for="err in autoGenResult.errors.slice(0, 20)"
                :key="err.id"
              >
                {{ err.name || err.id }}: {{ err.reason }}
              </li>
            </ul>
          </div>
        </div>
      </b-modal>
      <card>
        <div>
          <div class="col-sm-12 p-3">
            <el-table stripe style="width: 100%;" :data="queriedData" border>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              ></el-table-column>
              <el-table-column :min-width="100" label="Status">
                <template slot-scope="props">
                  <span @click="handleSwitch(props.$index, props.row)">
                    <l-switch
                      :value="getIsSDiableTag(props.row)"
                      class="status"
                    ></l-switch>
                  </span>
                </template>
              </el-table-column>
              <el-table-column :min-width="100" fixed="right" label="Actions">
                <template slot-scope="props">
                  <a
                    v-tooltip.top-center="'Edit'"
                    class="btn-warning btn-simple btn-link"
                    @click="handleEdit(props.$index, props.row)"
                  >
                    <i class="fa fa-edit"></i>
                  </a>
                  <a
                    v-tooltip.top-center="'Delete'"
                    class="btn-danger btn-simple btn-link"
                    v-b-modal.confirmDelete
                    @click="handleDelete(props.$index, props.row)"
                  >
                    <i class="fa fa-trash"></i>
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of
              {{ pagination.total }} entries
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            @input="clickCallback(pagination.currentPage)"
          ></l-pagination>
        </div>
      </card>
    </div>
    <bulk-metadata-dialog
      ref="bulkDialog"
      record-type="catalogue"
      @applied="onBulkApplied"
    ></bulk-metadata-dialog>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  Select,
  Option,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownItem,
} from 'element-ui'
import { Pagination as LPagination } from 'src/components/index'
import { Switch as LSwitch } from 'src/components'
import Fuse from 'fuse.js'
import { debounce } from 'debounce'
import DeleteConfirmation from 'src/pages/Dashboard/Components/DeleteConfirmation.vue'
import BulkMetadataDialog from 'src/pages/Dashboard/Components/BulkMetadataDialog.vue'
export default {
  components: {
    [Button.name]: Button,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    LPagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    LSwitch,
    DeleteConfirmation,
    BulkMetadataDialog,
  },

  data() {
    return {
      selectedCId: -1,

      searchQuery: '',
      propsToSearch: ['name', 'tags'],
      tableColumns: [
        {
          prop: 'name',
          label: 'Name',
          minWidth: 200,
        },
        {
          prop: 'type',
          label: 'Type',
          minWidth: 200,
        },
      ],
      fuseSearch: null,
      cataloguetypes: [
        {
          value: '',
          label: 'All',
        },
        {
          value: 'Category',
          label: 'Category',
        },
        {
          value: 'Playlist',
          label: 'Playlist',
        },
        {
          value: 'Root',
          label: 'Root',
        },
        {
          value: 'Season',
          label: 'Season',
        },
        {
          value: 'Series',
          label: 'Series',
        },
      ],
      catalogue_type: '',
      // ─── Auto-generate canonical URLs state ───
      autoGenType: '', // selected type filter for the bulk endpoint ("" = all types)
      autoGenLoading: false,
      autoGenStage: 'preview', // 'preview' | 'result'
      autoGenResult: null,
    }
  },

  computed: {
    pagination() {
      return this.$store.getters.getCataloguePagination
    },
    tableData() {
      if (this.catalogue_type.length > 0) {
        return this.$store.state.catalogue.catalogueList.filter(
          (item) => item.type === this.catalogue_type,
        )
      }
      return this.$store.state.catalogue.catalogueList
    },
    pagedData() {
      return this.tableData.slice(this.from, this.to)
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      let result = this.tableData
      // if (this.searchQuery !== "") {
      //   result = new Fuse(this.tableData, { keys: ["name"] }).search(
      //     this.searchQuery
      //   );
      // }
      //this.pagination.total = result.length;
      // return result.slice(this.from, this.to);
      return result
    },
    to() {
      let highBound = this.from + this.pagination.perPage
      if (highBound > this.pagination.perPage) {
        highBound = this.pagination.total
      }

      return highBound
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total() {
      this.pagination.total = this.tableData.length
      return this.tableData.length
    },
  },
  created() {
    this.$store.commit('setLoader', {
      show: true,
      text: 'Fetching Catalogue...',
    })

    this.$store
      .dispatch('getCatalogueList')
      .then((response) => {
        this.$store.commit('setLoader', { show: false, text: '' })
      })
      .catch((err) => {
        this.$store.commit('setLoader', { show: false, text: '' })
      })
  },
  mounted() {},
  beforeDestroy() {
    // this.$store.commit("setCatalogueList",{_list:[]})
    this.$store.commit('setCatalogueSearchText', '')
  },

  methods: {
    handleBulkAction(command) {
      if (command === 'bulk-metadata-upsert') {
        this.$refs.bulkDialog.open('upsert')
      } else if (command === 'bulk-metadata-delete') {
        this.$refs.bulkDialog.open('delete')
      }
    },
    onBulkApplied(payload) {
      this.$store.dispatch('getCatalogueList')
      this.$notify({
        title: 'Bulk update finished',
        message:
          (payload.counts.succeeded || 0) +
          ' succeeded, ' +
          (payload.counts.failed || 0) +
          ' failed, ' +
          (payload.counts.skipped || 0) +
          ' skipped.',
        type: payload.counts.failed > 0 ? 'warning' : 'success',
      })
    },
    clickCallback: function (pagNum) {
      if (this.$store.state.catalogue.inputPage != pagNum) {
        this.$store.commit('setCatalogueInputPage', pagNum)
        this.$store.commit('setLoader', {
          show: true,
          text: 'Fetching Catalogues...',
        })
        this.$store.dispatch('getCatalogueList').then(() => {
          this.$store.commit('setLoader', {
            show: false,
            text: '',
          })
        })
        return true
      }
    },
    changeperpage: function (perPage) {
      if (this.$store.state.catalogue.inputSize != perPage) {
        this.$store.commit('setCatalogueInputPage', 1)
        this.$store.commit('setCatalogueInputPerpage', perPage)
        this.$store.commit('setLoader', {
          show: true,
          text: 'Fetching Catalogues...',
        })
        this.$store
          .dispatch('getCatalogueList')
          .then(() => {
            this.$store.commit('setLoader', {
              show: false,
              text: '',
            })
          })
          .catch(() => {
            this.$store.commit('setLoader', {
              show: false,
              text: '',
            })
          })
        return true
      }
    },
    debounceInput: debounce(function () {
      this.searchCatalogue()
    }, 800),
    handleEdit: function (index, props) {
      this.$router.push({ name: 'Edit Catalogue', params: { id: props.id } })
    },
    searchCatalogue: function () {
      this.$store.commit('setLoader', {
        show: true,
        text: 'Searching',
      })
      this.$store.commit('setCatalogueInputPage', 1)
      this.$store.commit('setCatalogueSearchText', this.$refs.searchKey.value)
      this.$store
        .dispatch('getCatalogueList')
        .then((response) => {
          this.$store.commit('setLoader', { show: false, text: '' })
        })
        .catch(() => {
          this.$store.commit('setLoader', { show: false, text: '' })
        })
      return true
    },
    handleWatchVideo: function (index, props) {},

    handleDelete: function (index, props) {
      this.selectedCId = props.id
    },

    addUser: function () {
      this.$router.push({ name: 'Edit Catalogue', params: { id: '-1' } })
    },
    // ─── Auto-generate canonical URLs ───
    autoGenerateRun(dryRun) {
      this.autoGenLoading = true
      this.autoGenStage = 'preview'
      this.autoGenResult = null
      var payload = { dryRun: !!dryRun }
      if (this.autoGenType) payload.type = this.autoGenType
      this.$store
        .dispatch('autoGenerateCatalogueCanonicalUrls', payload)
        .then((result) => {
          this.autoGenLoading = false
          this.autoGenResult = result || {}
          this.autoGenStage = dryRun ? 'preview' : 'result'
          this.$refs.autoGenModal.show()
          if (!dryRun) {
            // refresh the list so newly-set canonical URLs are visible
            this.$store.dispatch('getCatalogueList')
          }
        })
        .catch((err) => {
          this.autoGenLoading = false
          var msg = 'Auto-generate failed.'
          if (
            err &&
            err.response &&
            err.response.data &&
            err.response.data.message
          ) {
            msg = err.response.data.message
          }
          this.$notify({
            title: 'Error',
            message: msg,
            type: 'warning',
          })
        })
    },
    onAutoGenModalOk(bvEvt) {
      if (this.autoGenStage === 'preview') {
        // Prevent the modal from auto-closing — we'll close it after the real run finishes.
        bvEvt.preventDefault()
        this.autoGenerateRun(false)
      }
      // result stage: default OK behavior closes the modal
    },
    deleteCatalogue: function () {
      if (this.selectedCId && this.selectedCId != -1) {
        this.$store
          .dispatch('deleteCatalogue', this.selectedCId)
          .then((data) => {
            this.$store.dispatch('getCatalogueList')
          })
          .catch(() => {})
      }
    },
    getStatus(row) {
      if (row.isActive) return 'Active'
      return 'InActive'
    },
    getIsSDiableTagText: function (item) {
      if (item.isActive == true) {
        return 'TRUE'
      } else {
        return 'FALSE'
      }
    },
    getIsSDiableTag: function (item) {
      if (item.isActive == true) {
        return true
      } else {
        return false
      }
    },
    handleSwitch: function (index, props) {
      if (props.id) {
        if (index >= 0) {
          // var data = this.$store.state.catalogue.catalogueList[index];
          var data = props
          var req = {}
          if (data.isActive == false) {
            data.isActive = true
          } else {
            data.isActive = false
          }
          var DataToSend = {
            isActive: data.isActive,
            id: data.id,
            _isDeleted: true,
          }
          req.id = data.id
          req.data = DataToSend
          self = this
          if (data.id) {
            this.$store
              .dispatch('updateCatalogue', req)
              .then((response) => {
                this.$store.dispatch('getCatalogueList')
                this.$notify({
                  title: 'Success',
                  message: 'Catalogue Updated Successfully!',
                  type: 'success',
                })
              })
              .catch(() => {
                this.$notify({
                  title: 'Error',
                  message: 'Update Catalogue Failed!',
                  type: 'warning',
                })
                return
              })
          }
        }
      }
    },
  },
}
</script>

<style scoped>
.perPage {
  font-weight: 400;
  font-size: 14px;
  color: #27282a;
  letter-spacing: 0.7px;
}

.titleCard {
  margin-left: 15px;
  font-weight: 500;
  font-size: 22px;
  color: #27282a;
  position: relative;
  right: 16px;
}
.searchContainer {
  position: relative;
  left: 7px;
}
.filterWrapper {
  margin-right: 10px;
  width: 120px;
}
</style>
